import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { Topic, Value } from '../styles';

export const SectorName = () => {
	const {
		libertyMutualResult: {
			informations: { sector_name }
		}
	} = useLibertyMutualSubStepsContext();

	return (
		<Col xs={24}>
			<Topic>{I18n.get('Sector')}:</Topic>
			<Value>{sector_name}</Value>
		</Col>
	);
};
